import React from "react";
import PropTypes from "prop-types";

// Khung chung cho các tab Settings dạng bảng (Signers, Digital signature): một card,
// header có tiêu đề + trạng thái + nút, bảng ở giữa, footer ghi chú. Dùng chung để
// các tab trông như một bộ.

export const TH = "tw-px-3 tw-py-2 tw-text-left tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-geist-fg-3 tw-whitespace-nowrap";
export const TD = "tw-px-3 tw-py-2.5 tw-align-middle";
export const ROW = "tw-border-0 tw-border-b tw-border-solid tw-border-geist-border";

export const TONE = {
  ok: "tw-bg-[#ecfdf3] tw-text-[#067647]",
  warn: "tw-bg-[#fff8ee] tw-text-[#a05e03]",
  bad: "tw-bg-[#fdf2f0] tw-text-[#8e2a18]",
  muted: "tw-bg-geist-100 tw-text-geist-fg-3",
};

export const Chip = ({ tone, icon, children, title }) => (
  <span title={title}
    className={`tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-[11px] tw-font-semibold tw-whitespace-nowrap ${tone}`}>
    {icon && <i className={`bi ${icon}`} />}{children}
  </span>
);

Chip.propTypes = {
  tone: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
};

/** Card bảng: header (title, subtitle, status chips, actions) + body + footer. */
export const SettingsCard = ({ title, subtitle, status, actions, footer, children }) => (
  <div className="tw-rounded-geist-md tw-border tw-border-solid tw-border-geist-border tw-bg-white tw-shadow-geist-card tw-overflow-hidden">
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3 tw-px-5 tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-geist-border">
      <div className="tw-min-w-0 tw-flex-1">
        <div className="tw-text-sm tw-font-semibold tw-text-geist-fg">{title}</div>
        {subtitle && <div className="tw-text-[12px] tw-text-geist-fg-3">{subtitle}</div>}
      </div>
      {status && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">{status}</div>}
      {actions && <div className="tw-flex tw-items-center tw-gap-2">{actions}</div>}
    </div>
    {children}
    {footer && (
      <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-px-5 tw-py-2.5 tw-bg-geist-bg-2 tw-border-0 tw-border-t tw-border-solid tw-border-geist-border">
        {footer}
      </div>
    )}
  </div>
);

SettingsCard.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  status: PropTypes.node,
  actions: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
};

/** Dòng nhóm trong bảng (vd "Hub-Sign", "VNPT SmartCA") — vai trò như số bước bên Signers. */
export const GroupRow = ({ colSpan, icon, title, subtitle, status }) => (
  <tr className={`${ROW} tw-bg-geist-bg-2/60`}>
    <td className={`${TD} tw-py-2`} colSpan={colSpan}>
      <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        {icon && (
          <span className="tw-inline-flex tw-h-6 tw-w-6 tw-items-center tw-justify-center tw-rounded-full tw-bg-geist-accent tw-text-white tw-text-[11px]">
            <i className={`bi ${icon}`} />
          </span>
        )}
        <span className="tw-text-sm tw-font-semibold tw-text-geist-fg">{title}</span>
        {subtitle && <span className="tw-text-[12px] tw-text-geist-fg-3">· {subtitle}</span>}
        {status && <span className="tw-ml-auto">{status}</span>}
      </div>
    </td>
  </tr>
);

GroupRow.propTypes = {
  colSpan: PropTypes.number,
  icon: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  status: PropTypes.node,
};

/** Công tắc bật/tắt (role="switch"); `disabled` = không bấm được. */
export const Toggle = ({ checked, onChange, label, disabled = false }) => (
  <span role="switch" aria-checked={checked} aria-label={label} aria-disabled={disabled} tabIndex={disabled ? -1 : 0}
    onClick={() => { if (!disabled) onChange(!checked); }}
    onKeyDown={(e) => { if (!disabled && (e.key === " " || e.key === "Enter")) { e.preventDefault(); onChange(!checked); } }}
    className={`tw-relative tw-inline-flex tw-h-5 tw-w-9 tw-flex-shrink-0 tw-rounded-full tw-transition-colors ${checked ? "tw-bg-geist-accent" : "tw-bg-geist-border-2"} ${disabled ? "tw-cursor-not-allowed tw-opacity-50" : "tw-cursor-pointer"}`}>
    <span className={`tw-absolute tw-top-0.5 tw-h-4 tw-w-4 tw-rounded-full tw-bg-white tw-shadow tw-transition-all ${checked ? "tw-left-[18px]" : "tw-left-0.5"}`} />
  </span>
);

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};
